import React from 'react';
import { Route, Switch } from 'react-router-dom';

import Account from 'features/Account/Account';
import Dashboard from 'features/dashboard';
import Settings from 'features/Settings';
import ProfileContainer from 'features/Settings/profile/ProfileContainer';
import ClientListContainer from 'features/client/ClientListContainer/ClientListContainer';
import ClientNewContainer from 'features/client/ClientNewContainer';
import ClientEditContainer from 'features/client/ClientEditContainer';
import ReportsLayout from 'features/reports/ReportsLayout';
import TestListContainer from 'features/test/TestListContainer/TestListContainer';
import TestNewContainer from 'features/test/TestNewContainer';
import TestEditContainer from 'features/test/TestEditContainer';
import QaLayout from '../../../../features/qa/QaLayout';

const Main = () => {
  return (
    <div className="Main">
      <div className="container">
        <Switch>
          <Route exact path="/" component={Dashboard} />

          <Route path="/account" component={Account} />

          <Route exact path="/clients" component={ClientListContainer} />
          <Route exact path="/clients/new" component={ClientNewContainer} />
          <Route exact path="/clients/:id/edit" component={ClientEditContainer} />

          <Route path="/qa/crm" component={QaLayout} />
          <Route path="/reports" component={ReportsLayout} />

          <Route exact path="/settings" component={Settings} />
          <Route exact path="/settings/profile" component={ProfileContainer} />

          <Route exact path="/tests" component={TestListContainer} />
          <Route exact path="/tests/new" component={TestNewContainer} />
          <Route exact path="/tests/:id/edit" component={TestEditContainer} />

          <Route component={Dashboard} />
        </Switch>
      </div>
    </div>
  )
}

export default Main;



// WEBPACK FOOTER //
// ./src/components/layouts/LoggedIn/Main/index.jsx